/**
 * Entry de Contentful (content type `template`, environment Integration) que trae el
 * diccionario de mensajes de error de libranzas embebido como JSON dentro del campo
 * `tituloEnriquecido`. `useStaticQuery` no admite variables, así que este mismo id
 * también está quemado en el filtro GraphQL de `queries/useErroresLibranzasQuery.ts`:
 * si cambia aquí, hay que actualizar la query.
 */
export const ERRORES_LIBRANZAS_ENTRY_ID = 'nOwj87lMGQhbmfIEp3HRt';
